import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { Field, FormikProps, useFormikContext } from 'formik'
import { CheckboxInput } from '../../../../../../../components/inputs/CheckboxInput'

interface Props {}

export const DemolitionTechnicalFormB1E: React.FC<Props> = () => {
  const formik = useFormikContext() as FormikProps<any>
  return (
    <FormSectionTwoColumns
      title="e) způsob zajištění ochrany stávajících staveb civilní ochrany v území dotčeném stavbou"
      subtitle="jejich výčet a umístění, včetně popisu dotčenosti jejich funkce a provozuschopnosti"
      sectionKey="b1e"
    >
      <>
        <div className="sm:col-span-6 mt-5">
          <Field
            component={CheckboxInput}
            name="b1e.hasCivilDefenseBuildings"
            label="Stavby civilní ochrany v území"
          />
        </div>
        {formik?.values.b1e?.hasCivilDefenseBuildings && (
          <>
            <div className="sm:col-span-6 pl-7">
              <Field
                name="b1e.civilDefenseBuildings"
                label="Výčet a umístění staveb civilní ochrany"
                component={RichTextInput}
                aiHint={
                  'Výčet a umístění stávajících staveb civilní ochrany v území dotčeném stavbou'
                }
              />
            </div>
            <div className="sm:col-span-6 pl-7">
              <Field
                name="b1e.protectionMeasures"
                label="Způsob zajištění ochrany staveb civilní ochrany"
                component={RichTextInput}
                aiHint={
                  'Způsob zajištění ochrany stávajících staveb civilní ochrany včetně popisu dotčenosti jejich funkce a provozuschopnosti'
                }
              />
            </div>
          </>
        )}
      </>
    </FormSectionTwoColumns>
  )
}
